export const generalSetting = {
  version: '1.7.4.0',
  authKey: 'authEHospital',
  langKey: 'langEHospital',
  defaultLang: 'uz',
  imgPhotoUrl: '/assets/img/photo.jpg',

  calendarRu: {
    firstDayOfWeek: 1,
    dayNames: [
      'Воскресенье',
      'Понедельник',
      'Вторник',
      'Среда',
      'Четверг',
      'Пятница',
      'Субота',
    ],
    dayNamesShort: ['Вс', 'Пон', 'Вт', 'Ср', 'Чт', 'Пт', 'Су'],
    dayNamesMin: ['Вс', 'Пон', 'Вт', 'Ср', 'Чт', 'Пт', 'Су'],
    monthNames: [
      'Январь',
      'Февраль',
      'Март',
      'Апрель',
      'Май',
      'Июнь',
      'Июль',
      'Август',
      'Сентябрь',
      'Октябрь',
      'Ноябрь',
      'Декабрь',
    ],
    monthNamesShort: [
      'Янв',
      'Фев',
      'Мар',
      'Апр',
      'Май',
      'Июн',
      'Июл',
      'Авг',
      'Сен',
      'Окт',
      'Ноя',
      'Дек',
    ],
    today: 'Сегодня',
    clear: 'Очистить',
  },
  fullCalendarRu: {
    header: {
      left: 'Назад,Вперед',
      center: 'Календарное представление данных',
      right: 'месяц,неделя,день',
    },
  },
  calendarUzLat: {
    firstDayOfWeek: 1,
    dayNames: [
      'Yakshanba',
      'Dushanba',
      'Seshanba',
      'Chorshanba',
      'Payshanba',
      'Juma',
      'Shanba',
    ],
    dayNamesShort: ['Yak', 'Du', 'Se', 'Ch', 'Pay', 'Ju', 'Sh'],
    dayNamesMin: ['Yak', 'Du', 'Se', 'Ch', 'Pay', 'Ju', 'Sh'],
    monthNames: [
      'Yanvar',
      'Fevral',
      'Mart',
      'Aprel',
      'May',
      'Iyun',
      'Iyul',
      'Avgust',
      'Senyabr',
      'Oktabr',
      'Noyabr',
      'Dekabr',
    ],
    monthNamesShort: [
      'Yan',
      'Fev',
      'Mar',
      'Apr',
      'May',
      'Iyn',
      'Iyl',
      'Avg',
      'Sen',
      'Okt',
      'Noy',
      'Dek',
    ],
    today: 'Bugun',
    clear: 'Tozalash',
  },
  fullCalendarUzLat: {
    header: {
      left: 'Ortga,Oldinga',
      center: "Ma'lumotlaring kalendar ko'rinishi",
      right: 'oy,hafta,kun',
    },
  },
  calendarUzCyr: {
    firstDayOfWeek: 1,
    dayNames: [
      'Якшанба',
      'Душанба',
      'Сешанба',
      'Чоршанба',
      'Пайшанба',
      'Жума',
      'Шанба',
    ],
    dayNamesShort: ['Як', 'Ду', 'Се', 'Чор', 'Пай', 'Жу', 'Ша'],
    dayNamesMin: ['Вс', 'Пон', 'Вт', 'Ср', 'Чт', 'Пт', 'Су'],
    monthNames: [
      'Январь',
      'Февраль',
      'Март',
      'Апрель',
      'Май',
      'Июнь',
      'Июль',
      'Август',
      'Сентябрь',
      'Октябрь',
      'Ноябрь',
      'Декабрь',
    ],
    monthNamesShort: [
      'Янв',
      'Фев',
      'Мар',
      'Апр',
      'Май',
      'Июн',
      'Июл',
      'Авг',
      'Сен',
      'Окт',
      'Ноя',
      'Дек',
    ],
    today: 'Бугун',
    clear: 'Тозалаш',
  },
  fullCalendarUzCyr: {
    header: {
      left: 'Ортга,Олдинга',
      center: 'Маълумотларинг календарь кўриниши',
      right: 'ой,ҳафта,кун',
    },
  },
  calendarEng: {
    firstDayOfWeek: 0,
    dayNames: [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday, Saturday',
    ],
    dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    monthNames: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ],
    monthNamesShort: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ],
    today: 'Today',
    weekHeader: 'Wk',
  },
  tvRefreshMinut: 30, // 20 sekund
};
